"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./styles/app.css");
const webix_jet_1 = require("webix-jet");
const globals_1 = require("models/globals");
class Login extends webix_jet_1.JetApp {
    constructor(config = {}) {
        const defaults = {
            id: APPNAME,
            version: VERSION,
            debug: !PRODUCTION,
            start: "/login"
        };
        super(Object.assign(Object.assign({}, defaults), config));
    }
}
exports.default = Login;
if (!BUILD_AS_MODULE) {
    const app = new Login();
    // @ts-ignore		Sp�cifi� avant chargement dans index.html
    app.use(webix_jet_1.plugins.Locale, { lang: lang });
    // @ts-ignore		Sp�cifi� avant chargement dans index.html
    webix.i18n.setLocale(langue);
    // Pour l'europe, la semaine commence le lundi
    // if (langue == "fr-FR") {
    webix.Date.startOnMonday = true;
    // }
    (0, globals_1.initTranslation)(app.getService("locale")._);
    webix.ready(() => app.render());
}
